import { GzRemoveADIntegratorWebComponent } from './component/GzRemoveADIntegratorWebComponent';

export { GzRemoveADIntegratorWebComponent };
